import { useRouteError } from 'react-router-dom';
import ErrorDisplay from './ErrorDisplay';

const ErrorElement = () => {
  const error = useRouteError();

  return (
    <ErrorDisplay
      error={error}
      isDevelopment={process.env.NODE_ENV === 'development'}
      onResetClick={() => window.location.href = '/'}
    />
  );
};

export default ErrorElement;
